// session/SessionProvider.jsx
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { httpRequest } from "../utils/httpRequest";

const SessionContext = createContext(null);

const keysFromPermissions = (permissions) =>
  Array.isArray(permissions)
    ? permissions
        .map((p) => (typeof p === "string" ? p : p?.key))
        .filter(Boolean)
    : [];

// اولویت با permissions که از سرور می‌آید؛ اگر نبود → perms قدیمی
const buildEffectivePerms = (u) => {
  const fromServer = keysFromPermissions(u?.permissions);
  if (fromServer.length) return Array.from(new Set(fromServer));
  const fromLocal = Array.isArray(u?.perms) ? u.perms : [];
  return Array.from(new Set(fromLocal));
};

export function SessionProvider({ children }) {
  const [user, setUser] = useState(() =>
    JSON.parse(localStorage.getItem("user") || "null")
  );
  const [loading, setLoading] = useState(true);

  const fetchMe = async () => {
    const cached = JSON.parse(localStorage.getItem("user") || "null");
    if (!cached?.token) {
      setUser(null);
      return null;
    }
    const { data } = await httpRequest(
      "GET",
      "/user/" + cached?._id,
      {},
      { "x-access-token": cached.token }
    );
    const serverUser = data?.data || {};
    const permsFinal =
      buildEffectivePerms(serverUser) || buildEffectivePerms(cached);
    const nextUser = {
      ...cached,
      ...serverUser,
      token: serverUser.token || cached.token,
      perms: permsFinal, // ⬅️ همگام با permissions
    };
    localStorage.setItem("user", JSON.stringify(nextUser));
    setUser(nextUser);
    return nextUser;
  };

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        await fetchMe();
      } catch {
        setUser(
          (prev) => prev || JSON.parse(localStorage.getItem("user") || "null")
        );
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    // سینک بین تب‌ها
    const onStorage = (e) => {
      if (e.key === "user")
        setUser(JSON.parse(localStorage.getItem("user") || "null"));
    };
    window.addEventListener("storage", onStorage);
    return () => {
      mounted = false;
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  const value = useMemo(
    () => ({
      user,
      loading,
      refreshUser: async () => {
        setLoading(true);
        try {
          await fetchMe();
        } finally {
          setLoading(false);
        }
      },
    }),
    [user, loading]
  );

  return (
    <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
  );
}

export const useSession = () => useContext(SessionContext);
